export default __webpack_public_path__ + "static/media/aginpro.b8a4ca8d.jpg";